import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { getUrlForStudent, getUrlForAgency, getUrlForKoach } from "helpers/NotificationLinkHelper";

const NoticeLinkLanding = (props: any) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { info: myInfo } = useSelector((state: any) => state.user);

    // 모든 쿼리스트링을 객체로 변환
    const queryParams = Object.fromEntries(searchParams.entries());

    useEffect(() => {
        let link = "/";
        console.log({ myInfo });
        if (myInfo?.accountTypeCode === "accountType:student") {
            link = getUrlForStudent(queryParams);
        } else if (myInfo?.accountTypeCode === "accountType:agency") {
            link = getUrlForAgency(queryParams);
        } else if (myInfo?.accountTypeCode === "accountType:school") {
            link = "/school/notification";
        } else if (myInfo?.accountTypeCode === "accountType:koach") {
            link = getUrlForKoach(queryParams);
        }
        navigate(link);
    }, [queryParams]);

    return (
        (process.env.REACT_APP_ENV !== "local" && process.env.REACT_APP_ENV !== "prod") && (
            <main className="bg-gray-50 min-h-screen">
                <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-6 sm:pt-6 lg:pt-6">
                    <h1 className="text-3xl font-bold text-gray-900 mb-6">Notice Link Landing</h1>
                    <div className="bg-white rounded-lg shadow p-6">
                        <h2 className="text-xl font-semibold text-gray-800 mb-4">쿼리스트링 정보</h2>
                        {Object.keys(queryParams).length > 0 ? (
                            <dl className="space-y-2">
                                {Object.entries(queryParams).map(([key, value]) => (
                                    <div key={key} className="flex border-b border-gray-200 py-2">
                                        <dt className="font-medium text-gray-700 w-1/3">{key}:</dt>
                                        <dd className="text-gray-600 w-2/3">{value}</dd>
                                    </div>
                                ))}
                            </dl>
                        ) : (
                            <p className="text-gray-500">쿼리스트링이 없습니다.</p>
                        )}
                        <div className="mt-4 pt-4 border-t border-gray-200">
                            <p className="text-sm text-gray-600">
                                전체 쿼리스트링: <code className="bg-gray-100 px-2 py-1 rounded">{searchParams.toString() || '(없음)'}</code>
                            </p>
                        </div>
                    </div>
                </div>
            </main>
        )
    );
};

export default NoticeLinkLanding;